export const musicCollection_8077 = {
    "@type": "Context",
    "id": 8077,
    "title": "Metal",
    "description": "12",
    "lastChanged": null,
    "changeableParameter": [
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Instrumental Accompaniment",
            "metadataDisplayType": "TEXT_CHECKBOX_SELECTION",
            "metadataDisplayName": "Instrumental Accompaniment",
            "value": [
                {
                    "value": "Guitar Band",
                    "selected": true
                },
                {
                    "value": "ALL_OTHERS",
                    "selected": true
                }
            ]
        },
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Substyle",
            "metadataDisplayType": "TEXT_CHECKBOX_SELECTION",
            "metadataDisplayName": "Substyle",
            "value": [
                {
                    "value": "Black Metal",
                    "selected": true
                },
                {
                    "value": "Death Metal",
                    "selected": true
                },
                {
                    "value": "Gothic",
                    "selected": true
                },
                {
                    "value": "Hardcore",
                    "selected": true
                },
                {
                    "value": "Heavy Metal",
                    "selected": true
                },
                {
                    "value": "Industrial",
                    "selected": true
                },
                {
                    "value": "Nu Metal",
                    "selected": true
                },
                {
                    "value": "Power Metal",
                    "selected": true
                },
                {
                    "value": "Thrash Metal",
                    "selected": true
                },
                {
                    "value": "ALL_OTHERS",
                    "selected": true
                }
            ]
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "year",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "year",
            "minimum": 1980,
            "maximum": 2019,
            "step": 1,
            "lowerSelection": 1980,
            "upperSelection": 2019,
            "metadataDisplayMinimum": "-",
            "metadataDisplayMaximum": "+"
        },
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Mood",
            "metadataDisplayType": "TEXT_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "Mood",
            "value": [
                {
                    "value": "Social",
                    "selected": true
                },
                {
                    "value": "Bright",
                    "selected": true
                },
                {
                    "value": "Dynamic",
                    "selected": true
                },
                {
                    "value": "Exuberant",
                    "selected": true
                }
            ]
        }
    ],
    "defaultChangeableParameter": [
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Instrumental Accompaniment",
            "metadataDisplayType": "TEXT_CHECKBOX_SELECTION",
            "metadataDisplayName": "Instrumental Accompaniment",
            "value": [
                {
                    "value": "Guitar Band",
                    "selected": true
                },
                {
                    "value": "ALL_OTHERS",
                    "selected": true
                }
            ]
        },
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Substyle",
            "metadataDisplayType": "TEXT_CHECKBOX_SELECTION",
            "metadataDisplayName": "Substyle",
            "value": [
                {
                    "value": "Black Metal",
                    "selected": true
                },
                {
                    "value": "Death Metal",
                    "selected": true
                },
                {
                    "value": "Gothic",
                    "selected": true
                },
                {
                    "value": "Hardcore",
                    "selected": true
                },
                {
                    "value": "Heavy Metal",
                    "selected": true
                },
                {
                    "value": "Industrial",
                    "selected": true
                },
                {
                    "value": "Nu Metal",
                    "selected": true
                },
                {
                    "value": "Power Metal",
                    "selected": true
                },
                {
                    "value": "Thrash Metal",
                    "selected": true
                },
                {
                    "value": "ALL_OTHERS",
                    "selected": true
                }
            ]
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "year",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "year",
            "minimum": 1980,
            "maximum": 2019,
            "step": 1,
            "lowerSelection": 1980,
            "upperSelection": 2019,
            "metadataDisplayMinimum": "-",
            "metadataDisplayMaximum": "+"
        },
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Mood",
            "metadataDisplayType": "TEXT_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "Mood",
            "value": [
                {
                    "value": "Social",
                    "selected": true
                },
                {
                    "value": "Bright",
                    "selected": true
                },
                {
                    "value": "Dynamic",
                    "selected": true
                },
                {
                    "value": "Exuberant",
                    "selected": true
                }
            ]
        }
    ],
    "visible": true,
    "editable": false,
    "favourite": false,
    "selected": false,
    "mostPlayed": false,
    "defaultSelected": false
}